import React from 'react';
import {
    HashRouter as Router,
    Switch,
    Route,
} from "react-router-dom";

import AdminLoginLayout from '../component/layout/AdminLoginLayout';
import AdminLayout from '../component/layout/AdminLayout';

import Users from '../component/AdminComponent/Users';
import Dashboard from '../component/AdminComponent/Dashboard';
import Chapters from '../component/AdminComponent/Chapters';
import ChapterQuestions from '../component/AdminComponent/ChapterQuestions';
import AssesmentQuestions from '../component/AdminComponent/AssesmentQuestions';
import UsersQueries from '../component/AdminComponent/UsersQueries';

const AdminContainer = () => {

    return (
        <Router basename="/admin">
            <Route path="/login">
                <AdminLoginLayout />
            </Route>
            <AdminLayout>
                <Switch>
                    <Route path="/Users">
                        <Users />
                    </Route>
                    <Route path="/Dashboard">
                        <Dashboard />
                    </Route>
                    <Route path="/Chapters">
                        <Chapters />
                    </Route>
                    <Route path="/ChapterQuestions">
                        <ChapterQuestions />
                    </Route>
                    <Route path="/AssesmentQuestions">
                        <AssesmentQuestions />
                    </Route>
                    <Route path="/UsersQueries">
                        <UsersQueries />
                    </Route>
                </Switch>
            </AdminLayout>

        </Router>
    )
}

export default AdminContainer